<template>
    <v-card :color="cardColor" :dark="computeCardDark" style="border-radius: 8px">
        <v-card-title>
            <div class="layout row ma-0 pt-2">
                <div class="subheading">{{title}}</div>
                <v-spacer></v-spacer>
                <div class="caption">{{subTitle}}</div>
                <v-btn icon dark style="margin-top: -10px" @click="onIconClick">
                    <v-icon small>{{icon}}</v-icon>
                </v-btn>
            </div>
        </v-card-title>
        <v-card-text class="pa-0 white--text">
            <slot v-if="showSlot"></slot>
            <e-chart v-else-if="hasData"
                     :path-option="computeChartOption"
                     height="308px"
                     width="100%">
            </e-chart>
            <v-layout v-else align-center  style="height: 308px; width:100%">
                <v-flex class="text-xs-center">
                    <v-progress-circular
                            v-if="isLoading"
                            :size="70"
                            :width="7"
                            color="white"
                            indeterminate
                    ></v-progress-circular>
                    <label v-else-if="!hasData" v-t="'appMsg.gridNoData'" class="title text-xs-center"></label>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
   import EChart from '../../chart/echart';
   import Material from 'vuetify/es5/util/colors';

   export default {
      components: {
         EChart
      },
      props: {
         title: String,
         gradient: {
            type: Boolean,
            default: false,
         },
         subTitle: String,
         icon: String,
         cardColor: {
            type: String,
            default: 'white'
         },
         iconColor: {
            type: String,
            default: 'success',
         },
         type: String,
         chartColor: Array,
         data: Array,
         loading: Boolean
      },
      data() {
         return {
            showSlot: false,
            isLoading: false,

            defaultOption: [
               ['xAxis.show', false],
               ['yAxis.show', false],
               ['grid.top', '15%'],
               ['grid.left', '0'],
               ['grid.bottom', '0'],
               ['grid.right', '0'],
               ['color', this.chartColor],
            ]
         };
      },

      watch: {
         loading: {
            immediate: true,
            handler: function (newValue) { //some delay to the loading status to give time data to be loaded.
               if (!newValue)
                  setTimeout(() => this.isLoading = false, 100);
               else
                  this.isLoading = true;
            }
         }
      },

      methods: {
         onIconClick() {
            this.showSlot = !this.showSlot;
            this.$emit('onIconClick');
         }
      },

      computed: {
         hasData() {
            return Boolean(Array.isArray(this.data) && this.data.length);
         },
         computeCardDark() {
            return this.cardColor !== 'white';
         },
         computeChartOption() {
            switch (this.type) {
               case 'bar':
                  this.defaultOption.push(['series[0].type', 'bar']);
                  this.defaultOption.push(['series[0].barWidth', '50%']);
                  // add shadow series
                  // this.defaultOption.push(['series[1].type', 'bar']);
                  break;
               case 'stack-bar':
                  // set stacked bar
                  // this.defaultOption.push(['series[0].data', StackBarData]);
                  this.defaultOption.push(['series[0].type', 'bar']);
                  this.defaultOption.push(['series[0].itemStyle.normar.color', 'rgba(0,0,0,0.05)']);
                  this.defaultOption.push(['series[0].barGap', '-100%']);
                  // set main series
                  // this.defaultOption.push(['series[1].data', StackData]);
                  this.defaultOption.push(['series[1].type', 'bar']);
                  break;
               case 'area':
                  this.defaultOption.push(['series[0].type', 'line']);
                  this.defaultOption.push(['series[0].smooth', true]);
                  this.defaultOption.push(['xAxis.boundaryGap', false]);
                  this.defaultOption.push(['series[0].areaStyle', {}]);
                  if (this.gradient) {
                     this.defaultOption.push(['series[0].areaStyle', {
                        normal: {
                           color: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                              {
                                 offset: 0,
                                 color: this.chartColor[0],
                              },
                              {
                                 offset: 1,
                                 color: this.chartColor[1],
                              }
                           ])
                        }
                     }]);
                  }

                  break;
               default:
                  // line
                  this.defaultOption.push(['series[0].smooth', true]);
                  this.defaultOption.push(['xAxis.boundaryGap', false]);
                  break;
            }

            this.defaultOption.push(['dataset.source', this.data]);

            return this.defaultOption;
         }
      }

   };
</script>

<style>

</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/widgets/chart/BoxChart.vue